module.exports = __webpack_public_path__ + "static/AtlasGold-aa5ae38bbd145162808b719071c388b1.png";